import { render } from "./pos_component.vue?vue&type=template&id=77a122e2"
import script from "./pos_component.vue?vue&type=script&lang=js"
export * from "./pos_component.vue?vue&type=script&lang=js"

import "./pos_component.vue?vue&type=style&index=0&id=77a122e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__